import { z } from 'zod';
// ---------------------------------------------------------------------------
// 공지 생성 스키마
// ---------------------------------------------------------------------------
export const CreateNoticeSchema = z.object({
    type: z.enum(['일반', '점검', '긴급', '업데이트'], {
        errorMap: () => ({ message: '유효한 공지 유형이 아닙니다' }),
    }),
    title: z.string().min(1, '제목을 입력하세요').max(50, '제목은 50자 이하로 입력하세요'),
    content: z.string().min(1, '본문을 입력하세요').max(500, '본문은 500자 이하로 입력하세요'),
    channels: z
        .array(z.enum(['app', 'web']))
        .min(1, '발송 채널을 1개 이상 선택하세요'),
    target: z.enum(['all', 'users', 'managers'], {
        errorMap: () => ({ message: '유효한 대상이 아닙니다' }),
    }),
    scheduledAt: z.string().datetime().nullable().optional(),
});
//# sourceMappingURL=notice.js.map